/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { Document } from '../../core/models/Document';
import { Node } from '../../core/models/Node';
import { NodePath } from '../../core/models/NodePath';
import { OasHeader } from '../../openapi/models/OasHeader';
import { IOasHeaderParent } from '../../openapi/models/IOasHeaderParent';
import { MarshallCompat } from '../../compat/MarshallCompat';

/**
 * A command used to delete all headers from a document.
 * @author vvilerio
 * @extends AbstractCommand
 * @class
 */
export class DeleteAllHeadersCommand extends AbstractCommand {
    public _parentPath : NodePath;

    public _oldHeaders : any;

    public constructor(parent? : any) {
        if(((parent != null && (parent["__interfaces"] != null && parent["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasHeaderParent") >= 0 || parent.constructor != null && parent.constructor["__interfaces"] != null && parent.constructor["__interfaces"].indexOf("io.apicurio.datamodels.openapi.models.IOasHeaderParent") >= 0)) || parent === null)) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaders===undefined) this._oldHeaders = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaders===undefined) this._oldHeaders = null;
            (() => {
                this._parentPath = Library.createNodePath(<Node><any>parent);
            })();
        } else if(parent === undefined) {
            let __args = arguments;
            super();
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaders===undefined) this._oldHeaders = null;
            if(this._parentPath===undefined) this._parentPath = null;
            if(this._oldHeaders===undefined) this._oldHeaders = null;
        } else throw new Error('invalid overload');
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#execute(Document)
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[DeleteAllHeadersCommand] Executing.");
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        let headers : Array<OasHeader> = parent.getHeaders();
        if(this.isNullOrUndefined(parent) || this.isNullOrUndefined(headers) || /* size */(<number>headers.length) === 0) {
            return;
        }
        this._oldHeaders = <any>({});
        let headersToRemove : Array<OasHeader> = <any>([]);
        for(let index172=0; index172 < headers.length; index172++) {
            let header = headers[index172];
            {
                /* put */(this._oldHeaders[header.getName()] = Library.writeNode(header));
                /* add */(headersToRemove.push(header)>0);
            }
        }
        if(/* size */Object.keys(this._oldHeaders).length === 0) {
            return;
        }
        headersToRemove.forEach(((parent) => {
            return (headerToRemove) => {
                parent.removeHeader(headerToRemove.getName());
            }
        })(parent));
    }

    /**
     * @see io.apicurio.datamodels.cmd.ICommand#undo(Document)
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[DeleteAllHeaders] Reverting.");
        if(this.isNullOrUndefined(this._oldHeaders) || /* size */Object.keys(this._oldHeaders).length === 0) {
            return;
        }
        let parent : IOasHeaderParent = <IOasHeaderParent><any>this._parentPath.resolve(document);
        if(this.isNullOrUndefined(parent)) {
            return;
        }
        {
            let array174 = /* keySet */Object.keys(this._oldHeaders);
            for(let index173=0; index173 < array174.length; index173++) {
                let k = array174[index173];
                {
                    let header : OasHeader = parent.createHeader(k);
                    Library.readNode(/* get */((m,k) => m[k]===undefined?null:m[k])(this._oldHeaders, k), header);
                    parent.addHeader(k, header);
                }
            }
        }
    }
}
DeleteAllHeadersCommand["__class"] = "io.apicurio.datamodels.cmd.commands.DeleteAllHeadersCommand";
DeleteAllHeadersCommand["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




